import cx from "classnames";
import React, { useState } from "react";
import UserActions from "@/actions/UserActions";
import AccountButton from "../../../../app2components/base/AccountButton";
import styles from "./CreateAccountForm.module.css";

function CreateAccountForm({ action, method, style, className }) {
  const [email, setEmail] = useState("");
  return (
    <form
      role="form"
      id="CreateAccountForm"
      action={action}
      method={method}
      style={style}
      className={cx(styles.form, className)}
      target="_blank"
    >
      <input type="hidden" name="_ref" value="app-demo" />
      <p className={styles.title}>
        Sign up FREE.
        <br />
        Continue building.
      </p>
      <p className={styles["sub-title"]}>
        Start your 14 day free trial
        <br />
        No credit card required.
      </p>

      <div className={styles["input-wrapper"]}>
        <input
          required
          type="email"
          className={styles["email-input"]}
          value={email}
          name="email"
          placeholder="EMAIL ADDRESS"
          onChange={(event) => setEmail(event.target.value)}
        />

        <AccountButton
          trackEvent={() =>
            UserActions.trackPostHogEvent(
              { event: "create_account_clicked" },
              { location: "signup_modal" },
            )
          }
          type="submit"
          form="CreateAccountForm"
          className={styles["submit-button"]}
        >
          CREATE MY ACCOUNT
        </AccountButton>
      </div>
    </form>
  );
}

export default CreateAccountForm;
